import React,{ Component } from 'react'
import Slider from "react-slick";
import Styles from '../../Css/Hotspot/Hotspot.module.css'
import { sliderSettings } from './HotSpotConfig'
import AtomicComponent from '../../AtomicComponents/AtomicComponents';

// redux and dispatch/action controller
import {
    updateCurrentImage, 
    updateCurrentImageRef,
    updateHotspot,
    updateCurrentHotSpotId,
    addHotspot,
    updateCurrentHotSpotObj
} from '../../Redux/Reducers/HotspotEditReducer/HotspotEditActionController'
import {connect} from 'react-redux'
import alertify from 'alertifyjs';

class HotspotImageTabView extends Component{

    constructor(props){
        super(props)
        this.state={
            imageList:[],
            freshLoad: true,
            //addOrUpdateHotspot: {},
            forceRender: true,
        }

        this.imgRef = this.props.imageList.map((img)=>{
            let newRef = React.createRef();
            return newRef;
        });

        this.currentHotspotId= '' ;

        this.imageNewDimensions = {
            isNewDimensionsUpdated : false,
            isPadByWidth: false,
            newImgWidth: 1,
            newImgHeight: 1,
            newContainerWidth: 1,
            newContainerHeight: 1,
            paddingHalf: 0
        }

    }
    
    componentDidMount = () => {

        window.addEventListener('resize', this.updateNewImageDimensionsForced);

        this.setState({
            ...this.state,
            imageList: [...this.props.imageList],
            // addOrUpdateHotspot: {
            //     ...this.props.addOrUpdateHotspot 
            // }
        });

        sliderSettings.nextArrow = <AtomicComponent.SampleNextArrow 
                                        customStyle={{width:"50px", margin: "auto", cursor:"pointer", fontSize:'30px'}}
                                        customClassName="slider-next slider-next-arrow" 
                                        arrowIconClass="fa fa-caret-right"
                                    />;

        sliderSettings.prevArrow = <AtomicComponent.SamplePrevArrow 
                                        customStyle={{width:"50px", margin: "auto", cursor:"pointer", fontSize:'30px'}} 
                                        customClassName="slider-prev slider-prev-arrow" 
                                        arrowIconClass="fa fa-caret-left"
                                    />
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateNewImageDimensionsForced);
    }


    updateNewImageDimensionsForced = async ()=>{
        try {
            // force fully update image dimensions and render the component
            await this.updateNewImageDimensions();
            this.setState({
                ...this.state,
                forceRender : !this.state.forceRender
            })
        } catch (error) {
            //console.log(error)
        }
    }

    /**
     * 
     * The below 2 functions are for testing purpose
     * to check if re rendering is done appropriately or not  
     */
    //shouldComponentUpdate(newProp, newState){
    //     let compareProps = this.shallowEqual(newProp, this.props);
    //     let compareState = this.shallowEqual(newState, this.state);
    //     console.log('compareProps',compareProps,'compareState',compareState);
    //     console.log('newProp',newProp);
    //     return ! (compareProps && compareState)
    // }

    // shallowEqual(object1, object2) {
    //     const keys1 = Object.keys(object1);
    //     const keys2 = Object.keys(object2);
      
    //     if (keys1.length !== keys2.length) {
    //       return false;
    //     }
      
    //     for (let key of keys1) {
    //       if (object1[key] !== object2[key]) {
    //         return false;
    //       }
    //     }
      
    //     return true;
    // }

    /**
     * This logic is added to control the slider change behaviour
     * @param {*} oldSlideIndex 
     * @param {*} newSlideIndex 
     */
    handleBeforeChangeSlider = (oldSlideIndex, newSlideIndex) =>{
        // image to load will have its data here
        this.props.updateCurrentImage(this.state.imageList[newSlideIndex]);
        this.props.updateCurrentImageRef(this.imgRef[newSlideIndex]);
        // don't show update desc or url option
        //this.props.updateIsAnyHotSpotSelected(false);
    }


    /**
     * Tab view sliick slide arrows display
     * @param {*} currentIndex 
     */
    handleAfterChangeSlide = (currentIndex) => {
        if(currentIndex===0 || currentIndex.index===0){
            // hide previous slide
            //document.getElementById('slider-next-arrow');
            const prevArrow = document.querySelectorAll('.slider-prev-arrow')[0];
            if(prevArrow)
                prevArrow.style.opacity = 0;
        }else{
            const prevArrow = document.querySelectorAll('.slider-prev-arrow')[0];
            if(prevArrow)
                prevArrow.style.opacity = 1;
        }

        if(currentIndex.index === this.state.imageList.length-1){
            const nextArrow = document.querySelectorAll('.slider-next-arrow')[0];
            if(nextArrow)
                nextArrow.style.opacity = 0;
        }else{
            const nextArrow = document.querySelectorAll('.slider-next-arrow')[0];
            if(nextArrow)
                nextArrow.style.opacity = 1; 
        }
    }
    /**
     * Based on 16:9 aspect ratio only
     */
    updateNewImageDimensions=()=>{
        try {
            if(this.props.currentImageRef && this.props.currentImageRef.current){
                const containerRef = this.props.currentImageRef.current;
                const containerCoordinates= containerRef.getBoundingClientRect()
                //console.log(document.getElementsByClassName('xslickListContainer')[0].getBoundingClientRect())

                const container = {
                    width: containerCoordinates.width,
                    height: containerCoordinates.height
                }

                const image = {
                    width: containerRef.children[0].naturalWidth,
                    height: containerRef.children[0].naturalHeight
                }

                let ratio_diff = parseFloat(container.height) / parseFloat(image.height) ;

                
                let newImage = {
                    width: parseFloat(ratio_diff) * image.width,
                    height: parseFloat(ratio_diff) * image.height
                }

                let padding = (container.width - newImage.width )/2;

                if(padding<0){
                    ratio_diff = parseFloat(container.width) / parseFloat(image.width);

                    newImage = {
                        width: ratio_diff * image.width,
                        height: ratio_diff * image.height
                    }


                    padding = (container.height - newImage.height )/2;

                    // console.log({
                    //     'ratio_diff': ratio_diff,
                    //     'image':image, 
                    //     'container':container,
                    //     'newImage': newImage,
                    //     'padding': padding
                    // })

                    this.imageNewDimensions = {
                        isNewDimensionsUpdated : true,
                        isPadByWidth: false,
                        newImgWidth: newImage.width || 1,
                        newImgHeight: newImage.height || 1,
                        newContainerWidth: container.width || 1,
                        newContainerHeight: container.height || 1,
                        paddingHalf: padding
                    }

                }else{

                    this.imageNewDimensions= {
                        isNewDimensionsUpdated : true,
                        isPadByWidth: true,
                        newImgWidth: newImage.width || 1,
                        newImgHeight: newImage.height || 1,
                        newContainerWidth: container.width || 1,
                        newContainerHeight: container.height || 1,
                        paddingHalf: padding
                    }

                    // console.log({
                    //     'ratio_diff': ratio_diff,
                    //     'image':image, 
                    //     'container':container,
                    //     'newImage': newImage,
                    //     'padding': padding
                    // })
                }
                //console.log(this.imageNewDimensions)

            }
        } catch (error) {
            //console.log(error)
        }
    }

    /**
     * This logic is added to update current
     * image's ref in store
     */
    componentDidUpdate = ()=>{

        if(this.state.freshLoad && this.imgRef.length){
            this.props.updateCurrentImage(this.state.imageList[0]);
            this.props.updateCurrentImageRef(this.imgRef[0]);
            this.setState({
                ...this.state,
                freshLoad: false
            }) 

            // hide prev button
            this.handleAfterChangeSlide(0);
        }

        this.updateNewImageDimensions();
    } 

    /**
     * 
     * @param {*} hotSpotId 
     * @returns 
     */
    findAndReturnCurrentHotSpot = (hotSpotId) => {
        let currentHotSpotObj = null;
        try {
            if(this.props.hotSpotMapObj && this.props.hotSpotMapObj.size && hotSpotId){
                let newHotSpotMapKeys = [...this.props.hotSpotMapObj.keys()];
                let currentObjFound = false;
                for(let i=0; i<newHotSpotMapKeys.length; i++){
                    let imageId = newHotSpotMapKeys[i];
                    let imageObj = this.props.hotSpotMapObj.get(imageId);
                    if(imageObj.imageHotSpots && imageObj.imageHotSpots.size && imageObj.imageHotSpots.has(hotSpotId)){
                        const hotSpotObj =  imageObj.imageHotSpots.get(hotSpotId);
                        let titleDescURL = null;
                        currentHotSpotObj = {...hotSpotObj};
                        if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                            titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotId);
                            currentHotSpotObj = {
                                ...hotSpotObj,
                                hotSpotTitle : titleDescURL.title ? titleDescURL.title : '',
                                hotSpotDesc : titleDescURL.desc ? titleDescURL.desc : '',
                                hotSpotURL : titleDescURL.url ? titleDescURL.url : '',
                                hotSpotCloseUpURL : titleDescURL.closeUpURL ? titleDescURL.closeUpURL : '',
                            }
                        }
                        currentObjFound = true;
                        break;
                    }

                    if(currentObjFound) break;

                }

                return currentHotSpotObj;
            }
        } catch (error) {
            //console.log(error);
        }

        return currentHotSpotObj;
    }
    /**
     * Update the current hotspotId and obj in store
     * @param {*} hotSpotId 
     */
    updateCurrHotSpotIdAndObj = async(hotSpotId)=>{
        try {
            let imageId = this.props.currentImageObj ? this.props.currentImageObj.image_id : '';

            if(!imageId || !hotSpotId){
                alertify.error('Unknow Error Occurred');
                throw new Error('Image id or hotSpotId came out as null from store');
            }
    
            // if the store's hotSpotId is same as prop's hot spot id, return
            //if(this.props.hotSpotId && this.props.hotSpotId===hotSpotId) return;

            let currentHotSpotObj = ( this.props.hotSpotMapObj && this.props.hotSpotMapObj.get(`${imageId}`) ) ? this.props.hotSpotMapObj.get(`${imageId}`).imageHotSpots.get(`${hotSpotId}`) : {};
    
            if(!currentHotSpotObj){
                const currentHotSpotObj = this.findAndReturnCurrentHotSpot(hotSpotId);

                // set in store if not null
                if(currentHotSpotObj){
                    this.props.updateCurrentHotSpotObj(currentHotSpotObj);
                }
            }

            if(hotSpotId !== currentHotSpotObj.hotSpotId) {
                // console.log('check this out: ', {
                //     hotSpotId,
                //     currentHotSpotObj
                // } );
                await this.getAndUpdateCurrentHotSpotObj(hotSpotId)
            }
    
            // before updating the currentHotSpotObj, check if such hotspot is having desc or URL match with sync obj in redux, if not update all those hotspots

            if(this.props.syncHotSpotTitleDescURL.has(hotSpotId)){
                const titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotId);

                if( (currentHotSpotObj.hotSpotTitle !== titleDescURL.title) ||  (currentHotSpotObj.hotSpotDesc !== titleDescURL.desc) || (currentHotSpotObj.hotSpotURL !== titleDescURL.url) || (currentHotSpotObj.hotSpotCloseUpURL !== titleDescURL.closeUpURL)){
                    // run whole update scenario
                    this.updateWholeMapWithTitleDescURL(hotSpotId,titleDescURL);

                    // update current hotspot object
                    currentHotSpotObj = ( this.props.hotSpotMapObj && this.props.hotSpotMapObj.get(`${imageId}`) ) ? this.props.hotSpotMapObj.get(`${imageId}`).imageHotSpots.get(`${hotSpotId}`) : {};
                }
            }

            this.props.updateCurrentHotSpotId(hotSpotId);
            this.props.updateCurrentHotSpotObj(currentHotSpotObj);

        } catch (error) {
            //console.log(error);
        }
    }


    /**
     * 
     * @param {*} titleDescURL : {title, desc, url}
     * @returns 
     */
    updateWholeMapWithTitleDescURL = (hotSpotId,titleDescURL)=>{
        try {
            if(!hotSpotId || !titleDescURL) return;

            let newHotSpotMapObj = new Map(this.props.hotSpotMapObj);

            let mapKeys = [...newHotSpotMapObj.keys()];

            mapKeys.forEach((key, index)=>{
                // if hotspot id is there, update title for it

                try {
                    if( newHotSpotMapObj.get(key).imageHotSpots &&  newHotSpotMapObj.get(key).imageHotSpots.has(hotSpotId) ) {     
                        newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotTitle = titleDescURL.title ? titleDescURL.title : '';
                        newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotTitle = titleDescURL.desc ? titleDescURL.desc : '';
                        newHotSpotMapObj.get(key).imageHotSpots.get(hotSpotId).hotSpotTitle = titleDescURL.url ? titleDescURL.url : '';
                    }            
                } catch (error) {
                    throw error;
                }


            });

            // finally update whole hotSpotMap obj in store
            this.props.updateWholeHotSpotMapObj(newHotSpotMapObj);
            
        } catch (error) {
            //console.log(error);
        }
    }

    // this logic is added to handle future cases, if any modification 
    // is required before updating
    handleUpdateHotspot = (hotspotObj, imageId)=>{
        this.props.updateHotspot(hotspotObj, imageId);
        // update currenthotspot also
        this.updateCurrHotSpotIdAndObj(hotspotObj.hotSpotId);

    }

    
/*****************MOUSE MOVE SUPPORT START***************************/
    /**
     * @todo: update current hotspot id from this as well as current hotspotObj based on current value
     * 
     * @param {*} e 
     */
    handleMouseDown = (e)=>{

        try {
        
            let parentRef = this.props.currentImageRef;
            let parentCoord = parentRef.current.getBoundingClientRect();
            let handleUpdateHotspot = this.handleUpdateHotspot;
            let imageId = this.props.currentImageObj ? this.props.currentImageObj.image_id : '';
            let syncObj = new Map(this.props.syncHotSpotTitleDescURL);
            if(!imageId){
                alertify.error('Unknow Error Occurred');
                throw new Error('Image id came out as null from store');
            }

            let currentHotSpotObj = ( this.props.hotSpotMapObj && this.props.hotSpotMapObj.get(`${imageId}`) ) ? this.props.hotSpotMapObj.get(`${imageId}`).imageHotSpots.get(`${e.target.id}`) : {};

            if(!currentHotSpotObj){
                alertify.error('Unknow Error Occurred');
                throw new Error('currentHotSpotObj came out as null from store');
            }


            // image dimensions for aspect ratio
            this.updateNewImageDimensions();
            const imageNewDimensions = this.imageNewDimensions;

            var move = function(event){

                event.stopPropagation();

                event.preventDefault();

                var originalLeft = parseInt(window.getComputedStyle(this).left);
                var originalTop = parseInt(window.getComputedStyle(this).top);

                var mouseDownX = event.clientX;
                var mouseDownY = event.clientY;


                function dragMe(event){
                    element.style.left = originalLeft + event.clientX - mouseDownX + "px";
                    element.style.top = originalTop + event.clientY - mouseDownY + "px";
                    event.stopPropagation();
                }

                function dropMe(event){
                    document.removeEventListener('mousemove',dragMe,true);
                    document.removeEventListener('mouseup',dropMe,true);
                
                    event.stopPropagation();

                    // once dropped, update the coordinate in store for this 
                    
                    //console.log(parentCoord);
                    let elementCoord = element.getBoundingClientRect();
                    
                    
                    // imageId and hotspotId

                    // at this point we will have left and top attributes, so get them, convert to 
                    // percent based on parent size and store it, discard if out of bound (will have its original value)

                    let leftOK=true, rightOK=true, topOK=true, bottomOK=true;

                    if(elementCoord.left < parentCoord.left) leftOK = false;
                    if(elementCoord.right > parentCoord.right) rightOK = false;
                    if(elementCoord.top < parentCoord.top) topOK = false;
                    if(elementCoord.bottom > parentCoord.bottom) bottomOK = false;

                    if(leftOK && rightOK && topOK && bottomOK) {
                        //console.log('dropped');
                        //console.log(parentRef.current.children[1].id);

                        const currentImagePixelFromLeft = elementCoord.left - parentCoord.left;
                        const currentImagePixelFromTop = elementCoord.top - parentCoord.top;
                        // let hotSpotJSON = {
                        //     ...currentHotSpotObj,
                        //     coordinates : {
                        //         xAxis: ((( currentImagePixelFromLeft ) / parentCoord.width) * 100).toFixed(4), 
                        //         yAxis: ((( currentImagePixelFromTop ) / parentCoord.height) *100).toFixed(4)
                        //     }
                        // }

                        let titleDescURL = null;
                        if(syncObj.has(hotSpotId)){
                            titleDescURL = syncObj.get(hotSpotId);
                        }

                        let hotSpotJSON = {
                            ...currentHotSpotObj,
                            hotSpotTitle: (titleDescURL && titleDescURL.title) ? titleDescURL.title : '',
                            hotSpotDesc: (titleDescURL && titleDescURL.desc) ? titleDescURL.desc : '',
                            hotSpotURL: (titleDescURL && titleDescURL.url) ? titleDescURL.url : '',
                            hotSpotCloseUpURL: (titleDescURL && titleDescURL.closeUpURL) ? titleDescURL.closeUpURL : '',
                            coordinates : {
                                xAxis: ((( currentImagePixelFromLeft ) / parentCoord.width) * 100), 
                                yAxis: ((( currentImagePixelFromTop ) / parentCoord.height) *100)
                            }
                        }

                        // after all this, update cordinates based on aspect ratio

                        /**
                         *  __________________________________
                         *  |			|x	x	x	x|		  |
                            |			|x O		x|		  |
                            |			|x			x|		  |
                            |___________|x__x___x___x|________|
                         *  |---padding-|            |-padding-|
                         * 
                         */

                        // means padding is from height, adjust top %age
                        if(!imageNewDimensions.isPadByWidth){
                            // what ever the coordinate get the % after adding one side of padding
                            const shouldBeTopCoordinate = currentImagePixelFromTop - imageNewDimensions.paddingHalf;

                            
                            // now calculate this distance from the left of image and convert to percentage
                            const topPercentage = (shouldBeTopCoordinate / imageNewDimensions.newImgHeight)*100;
                            
                            hotSpotJSON.coordinates.yAxis = topPercentage;
                        }else{
                            // adjust left %age
                            // what ever the coordinate get the % after adding one side of padding
                            const shouldBeLeftCoordinate = currentImagePixelFromLeft - imageNewDimensions.paddingHalf;

                            // now calculate this distance from the left of image and convert to percentage
                            const leftPercentage = (shouldBeLeftCoordinate / imageNewDimensions.newImgWidth)*100;
                            
                            hotSpotJSON.coordinates.xAxis = leftPercentage;
                        }

                        // console.log({
                        //     currentImagePixelFromLeft,
                        //     shouldBeLeftCoordinate,
                        //     currentImagePixelFromTop,
                        //     leftPercentage
                        // });

                        handleUpdateHotspot(hotSpotJSON, imageId);
                    }

                }

                document.addEventListener('mouseup',dropMe,true);
                document.addEventListener('mousemove',dragMe,true);

            }

            let element = e.target;
            let hotSpotId = e.target.id;
            // let newEle = Draggable(element,imageNewDimensions,hotSpotId,syncObj);
            element.classList.add('slickListContainerItemcentered');
            element.addEventListener('mousedown', move, false);

        } catch (error) {
            //console.log(error);
        }
        
    }
/*****************MOUSE MOVE SUPPORT END***************************/


    /**
     * Hotspot click handler
     * @param {*} e 
     */
    handleHotSpotClick = (e)=>{

        let hotSpotId = e.target.id;

        window.scrollTo(0,0); // logic here is to go to top of page if hotspot is clicked to maintaine left and top attributes of parent container as we use those for calculation
        // update current hotspot id as well as hotspot
        this.updateCurrHotSpotIdAndObj(hotSpotId);
        //this.props.updateIsAnyHotSpotSelected(true);
    }

    getAndUpdateCurrentHotSpotObj = (hotSpotIdToSearch)=>{
        try {
            if( this.props.currentHotSpotObj &&  this.props.currentHotSpotObj.hotSpotId !== hotSpotIdToSearch && this.props.hotSpotMapObj.size) {
                let newHotSpotMapKeys = [...this.props.hotSpotMapObj.keys()];

                for(let i=0; i<newHotSpotMapKeys.length; i++){
                    let imgKey = newHotSpotMapKeys[i];
                    let currentHotSpotObj = this.props.hotSpotMapObj.get(imgKey).imageHotSpots ? this.props.hotSpotMapObj.get(imgKey).imageHotSpots.get(hotSpotIdToSearch) : null;

                    if(currentHotSpotObj){
                        // update store's currentHotSpotObj with this obj
                        let currentHotSpotObjInStore = {
                            ...currentHotSpotObj,
                            coordinates: {
                                xAxis: 50, // in percent (during run time, convert it to pixel)
                                yAxis:  50// in percent (during run time, convert it to pixel)
                            }
                        }

                        // update in store
                        this.props.updateCurrentHotSpotObj(currentHotSpotObjInStore);
                        break;

                    }
                    
                }
                
            }
        } catch (error) {
            alertify.error('Unknown error occurred');
            //console.log(error);
        }
    }
    /**
     * Once Li selected, add similar hotspots to every frame
     * Throw error if same hotspot already present
     * @param {*} e 
     */
    handleAddSimilarHotspot = (e) =>{
        try {
            // Check if hotspot obj is present in the store
            let hotSpotObjToAdd = null;
            let imgId = e.target.id.replace('_img','');

            if(imgId && this.props.hotSpotMapObj){
                //we here means that imageId is there in map, search for hotSpotId
                let hotSpotIdToSearch = this.props.hotSpotId || '';
                
                if(!hotSpotIdToSearch) {
                    alertify.error('No hotspot available to add. Mark or create one to start adding');
                    return;
                }

                // now check if similar hotspot obj is available for this image, then throw error, else add one
                let isImageIdAvailableInMap = this.props.hotSpotMapObj.get(imgId);
                // finally add it to this frame
                hotSpotObjToAdd = this.props.currentHotSpotObj;

                let parentRef = this.props.currentImageRef;
                let parentCoord = parentRef.current.getBoundingClientRect();

                //let element = e.target;
                //let elementCoord = element.getBoundingClientRect();


                //console.log('hotSpotObjToAdd',hotSpotObjToAdd);
                // worst case, currentHotSpotObj isn't updated , run this func
                if( !hotSpotObjToAdd ) {
                    hotSpotObjToAdd = this.getAndUpdateCurrentHotSpotObj(hotSpotIdToSearch);
                }
                let hotSpotJSON = {};

                const currentImagePixelFromLeft = e.clientX - parentCoord.left;
                const currentImagePixelFromTop = e.clientY - parentCoord.top;



                if(!this.imageNewDimensions.paddingHalf) this.updateNewImageDimensions();

                // image dimensions for aspect ratio
                const imageNewDimensions = this.imageNewDimensions;

                let titleDescURL = null;
                if(this.props.syncHotSpotTitleDescURL.has(hotSpotIdToSearch)){
                    titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotIdToSearch);
                }
                // no such image id in map, add image id and add hotspot to it
                if(!isImageIdAvailableInMap) {
                    
                    hotSpotJSON = {
                        ...hotSpotObjToAdd,
                        imageId: imgId,
                        hotSpotTitle: (titleDescURL && titleDescURL.title) ? titleDescURL.title : '',
                        hotSpotDesc: (titleDescURL && titleDescURL.desc) ? titleDescURL.desc : '',
                        hotSpotURL: (titleDescURL && titleDescURL.url) ? titleDescURL.url : '',
                        hotSpotCloseUpURL: (titleDescURL && titleDescURL.closeUpURL) ? titleDescURL.closeUpURL : '',
                        coordinates: {
                            xAxis: ((( currentImagePixelFromLeft ) / parentCoord.width) * 100).toFixed(4), // in percent
                            yAxis: ((( currentImagePixelFromTop ) / parentCoord.height) *100).toFixed(4)// in percent
                        },
                        timeStamp: {
                            createdOn:Date.now(),
                            updatedOn:Date.now()
                        }
                    }
    
                    // delete mongoId property if present
                    //delete hotSpotJSON.mongoId

                    // means padding is from height, adjust top %age
                    if(!imageNewDimensions.isPadByWidth){
                        // what ever the coordinate get the % after adding one side of padding
                        const shouldBeTopCoordinate = currentImagePixelFromTop - imageNewDimensions.paddingHalf;

                                
                        // now calculate this distance from the left of image and convert to percentage
                        const topPercentage = (shouldBeTopCoordinate / imageNewDimensions.newImgHeight)*100;
                                
                        hotSpotJSON.coordinates.yAxis = topPercentage;
                    }else{
                        // adjust left %age
                        // what ever the coordinate get the % after adding one side of padding
                        const shouldBeLeftCoordinate = currentImagePixelFromLeft - imageNewDimensions.paddingHalf;

                        // now calculate this distance from the left of image and convert to percentage
                        const leftPercentage = (shouldBeLeftCoordinate / imageNewDimensions.newImgWidth)*100;
                                
                        hotSpotJSON.coordinates.xAxis = leftPercentage;
                    }


                    this.props.addHotspot(hotSpotJSON, imgId);

                    // force render
                    this.setState({
                        ...this.state,
                        forceRender: !this.state.forceRender
                    })
                    return;
                }else{
                    // in case image id is present in map and same hot spot is present, move it to this location
                    if ( this.props.hotSpotMapObj.get(imgId) && this.props.hotSpotMapObj.get(imgId).imageHotSpots && this.props.hotSpotMapObj.get(imgId).imageHotSpots.has(hotSpotIdToSearch) ){
                        // move current hotspot to this location

                        let titleDescURL = null;
                        if(this.props.syncHotSpotTitleDescURL.has(hotSpotIdToSearch)){
                            titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotIdToSearch);
                        }

                        let hotSpotJSON = {
                            ...this.props.hotSpotMapObj.get(imgId).imageHotSpots.get(hotSpotIdToSearch),
                            hotSpotTitle: (titleDescURL && titleDescURL.title) ? titleDescURL.title : '',
                            hotSpotDesc: (titleDescURL && titleDescURL.desc) ? titleDescURL.desc : '',
                            hotSpotURL: (titleDescURL && titleDescURL.url) ? titleDescURL.url : '',
                            hotSpotCloseUpURL: (titleDescURL && titleDescURL.closeUpURL) ? titleDescURL.closeUpURL : '',
                            coordinates : {
                                xAxis: ((( currentImagePixelFromLeft ) / parentCoord.width) * 100), 
                                yAxis: ((( currentImagePixelFromTop ) / parentCoord.height) *100)
                            }
                        }

                        // means padding is from height, adjust top %age
                        if(!imageNewDimensions.isPadByWidth){
                            // what ever the coordinate get the % after adding one side of padding
                            const shouldBeTopCoordinate = currentImagePixelFromTop - imageNewDimensions.paddingHalf;

                                    
                            // now calculate this distance from the left of image and convert to percentage
                            const topPercentage = (shouldBeTopCoordinate / imageNewDimensions.newImgHeight)*100;
                                    
                            hotSpotJSON.coordinates.yAxis = topPercentage;
                        }else{
                            // adjust left %age
                            // what ever the coordinate get the % after adding one side of padding
                            const shouldBeLeftCoordinate = currentImagePixelFromLeft - imageNewDimensions.paddingHalf;

                            // now calculate this distance from the left of image and convert to percentage
                            const leftPercentage = (shouldBeLeftCoordinate / imageNewDimensions.newImgWidth)*100;
                                    
                            hotSpotJSON.coordinates.xAxis = leftPercentage;
                        }

                        this.props.addHotspot(hotSpotJSON, imgId);

                        // force render
                        this.setState({
                            ...this.state,
                            forceRender: !this.state.forceRender
                        })

                        return;                    
                    }

                    let titleDescURL = null;
                    if(this.props.syncHotSpotTitleDescURL.has(hotSpotIdToSearch)){
                        titleDescURL = this.props.syncHotSpotTitleDescURL.get(hotSpotIdToSearch);
                    }

                    // else add this hot spot to image
                    hotSpotJSON = {
                        ...hotSpotObjToAdd,
                        imageId: imgId,
                        hotSpotTitle: (titleDescURL && titleDescURL.title) ? titleDescURL.title : '',
                        hotSpotDesc: (titleDescURL && titleDescURL.desc) ? titleDescURL.desc : '',
                        hotSpotURL: (titleDescURL && titleDescURL.url) ? titleDescURL.url : '',
                        hotSpotCloseUpURL: (titleDescURL && titleDescURL.closeUpURL) ? titleDescURL.closeUpURL : '',
                        coordinates: {
                            xAxis: ((( currentImagePixelFromLeft ) / parentCoord.width) * 100).toFixed(4), // in percent
                            yAxis: ((( currentImagePixelFromTop ) / parentCoord.height) *100).toFixed(4)// in percent
                        },
                        timeStamp: {
                            createdOn:Date.now(),
                            updatedOn:Date.now()
                        }
                    }
    
                    // delete mongoId property if present
                    //delete hotSpotJSON.mongoId

                    // means padding is from height, adjust top %age
                    if(!imageNewDimensions.isPadByWidth){
                        // what ever the coordinate get the % after adding one side of padding
                        const shouldBeTopCoordinate = currentImagePixelFromTop - imageNewDimensions.paddingHalf;

                                
                        // now calculate this distance from the left of image and convert to percentage
                        const topPercentage = (shouldBeTopCoordinate / imageNewDimensions.newImgHeight)*100;
                                
                        hotSpotJSON.coordinates.yAxis = topPercentage;
                    }else{
                        // adjust left %age
                        // what ever the coordinate get the % after adding one side of padding
                        const shouldBeLeftCoordinate = currentImagePixelFromLeft - imageNewDimensions.paddingHalf;

                        // now calculate this distance from the left of image and convert to percentage
                        const leftPercentage = (shouldBeLeftCoordinate / imageNewDimensions.newImgWidth)*100;
                                
                        hotSpotJSON.coordinates.xAxis = leftPercentage;
                    }

                    this.props.addHotspot(hotSpotJSON, imgId);

                    // force render
                    this.setState({
                        ...this.state,
                        forceRender: !this.state.forceRender
                    })
                    return;
                }



            }else{
                alertify.error('Unknow Error Occurred');
                throw new Error('Image id came out as null or mapObject was not present in the store');
            }
        } catch (error) {
            //console.log(error);
        }
    }

    calculateLeftAsPerAspect = (leftPercentageFromImageLeft)=>{
        try {
            if(!leftPercentageFromImageLeft) return 50


            this.updateNewImageDimensions();
            //console.log(this.imageNewDimensions);
            let newImageDimensions = this.imageNewDimensions;

            if(isNaN(newImageDimensions.newImgWidth) || isNaN(newImageDimensions.paddingHalf) || isNaN(newImageDimensions.newContainerWidth)) this.updateNewImageDimensions();
            
            newImageDimensions = this.imageNewDimensions; 

            if(!newImageDimensions.isPadByWidth) return leftPercentageFromImageLeft;

            // convert to pixels
            const leftPixelFromImgLeft = (leftPercentageFromImageLeft * newImageDimensions.newImgWidth )/100;

            const newLeftFromContainer = leftPixelFromImgLeft + newImageDimensions.paddingHalf;

            const newPercentFromContainer =  ( newLeftFromContainer / newImageDimensions.newContainerWidth )*100;

            // console.log({
            //     leftPixelFromImgLeft,
            //     newLeftFromContainer,
            //     newPercentFromContainer
            // });
            return newPercentFromContainer
        } catch (error) {
            //console.log(error);
        }
    }

    calculateTopAsPerAspect = (topPercentageFromImageTop)=>{
        try {
            if(!topPercentageFromImageTop) return 50;

            this.updateNewImageDimensions();
            //console.log(this.imageNewDimensions);
            let newImageDimensions = this.imageNewDimensions;

            if(isNaN(newImageDimensions.newImgHeight) || isNaN(newImageDimensions.paddingHalf) || isNaN(newImageDimensions.newContainerHeight)) this.updateNewImageDimensions();
            
            newImageDimensions = this.imageNewDimensions;
            
            if(newImageDimensions.isPadByWidth) return topPercentageFromImageTop;
            // convert to pixels
            const topPixelFromImgTop = (topPercentageFromImageTop * newImageDimensions.newImgHeight )/100;

            const newTopFromContainer = topPixelFromImgTop + newImageDimensions.paddingHalf;

            const newPercentFromContainer =  ( newTopFromContainer / newImageDimensions.newContainerHeight )*100;


            return newPercentFromContainer;

        } catch (error) {
            //console.log(error);   
        }
    }


/*****************TOUCH SCREEN MOVE SUPPORT START***************************/

    /**
     * Hotspot move on touch enabled devices
     * @param {*} event 
     * @returns 
     */
    moveTouch = (event)=>{
        try {
            event.stopPropagation();
            event.preventDefault();

            if (event.cancelable) {
                event.preventDefault();
             }

            if(!this.props.currentImageRef && !this.props.currentImageRef.current) return;

            const imageId = this.props.currentImageObj ? this.props.currentImageObj.image_id : '';

            if(!imageId){
                alertify.error('Unknow Error Occurred');
                throw new Error('Image id came out as null from store');
            }

            const currentHotSpotObj = ( this.props.hotSpotMapObj && this.props.hotSpotMapObj.get(`${imageId}`) ) ? this.props.hotSpotMapObj.get(`${imageId}`).imageHotSpots.get(`${event.target.id}`) : {};

            if(!currentHotSpotObj){
                alertify.error('Unknow Error Occurred');
                throw new Error('currentHotSpotObj came out as null from store');
            }
    
            // distance calculation
            const imgContainer = this.props.currentImageRef;
            const imgContainerCoord = imgContainer.current.getBoundingClientRect();
    
            const element = event.target;
            const originalLeftHotSpot = parseInt(window.getComputedStyle(element).left);
            const originalTopHotSpot = parseInt(window.getComputedStyle(element).top);
    
            var touchMoveX = (event.touches && event.touches.length) ? event.touches[0].clientX : null;
            var touchMoveY = (event.touches && event.touches.length) ? event.touches[0].clientY : null;
    
            if(!touchMoveX || !touchMoveY) throw Error('Unable to read touchmove event')
            const relativeX = touchMoveX - imgContainerCoord.left;
            const distanceToMoveX = relativeX - originalLeftHotSpot; 

            const relativeY = touchMoveY - imgContainerCoord.top;
            const distanceToMoveY = relativeY - originalTopHotSpot;

            //console.log({touchMoveX, touchMoveY, originalLeftHotSpot, originalTopHotSpot, imgContainerCoord,distanceToMoveX,distanceToMoveY});


            // new distance asssignment
            element.style.left = (originalLeftHotSpot + distanceToMoveX) + "px";
            element.style.top =  (originalTopHotSpot + distanceToMoveY)+ "px";
            
    
            // image dimensions for aspect ratio 16:9 
            const imageNewDimensions = this.imageNewDimensions;

            let leftOK=true, rightOK=true, topOK=true, bottomOK=true;

            const elementCoord = element.getBoundingClientRect();

            if(elementCoord.left < imgContainerCoord.left) leftOK = false;
            if(elementCoord.right > imgContainerCoord.right) rightOK = false;
            if(elementCoord.top < imgContainerCoord.top) topOK = false;
            if(elementCoord.bottom > imgContainerCoord.bottom) bottomOK = false;

            if(leftOK && rightOK && topOK && bottomOK) {
                //console.log('dropped');
                //console.log(parentRef.current.children[1].id);

                const currentImagePixelFromContainerLeft = elementCoord.left - imgContainerCoord.left;
                const currentImagePixelFromContainerTop = elementCoord.top - imgContainerCoord.top;

                // console.log({currentImagePixelFromContainerLeft,currentImagePixelFromContainerTop});
                // let hotSpotJSON = {
                //     ...currentHotSpotObj,
                //     coordinates : {
                //         xAxis: ((( currentImagePixelFromLeft ) / parentCoord.width) * 100).toFixed(4), 
                //         yAxis: ((( currentImagePixelFromTop ) / parentCoord.height) *100).toFixed(4)
                //     }
                // }

                

                let hotSpotJSON = {
                    ...currentHotSpotObj,
                    coordinates : {
                        xAxis: ((( currentImagePixelFromContainerLeft ) / imgContainerCoord.width) * 100), 
                        yAxis: ((( currentImagePixelFromContainerTop ) / imgContainerCoord.height) *100)
                    }
                }


                // after all this, update cordinates based on aspect ratio

                /**
                 *  __________________________________
                 *  |			|x	x	x	x|		  |
                    |			|x O		x|		  |
                    |			|x			x|		  |
                    |___________|x__x___x___x|________|
                 *  |---padding-|            |-padding-|
                 * 
                 */

              // means padding is from height, adjust top %age
              if(!imageNewDimensions.isPadByWidth){
                // what ever the coordinate get the % after adding one side of padding
                const shouldBeTopCoordinate = currentImagePixelFromContainerTop - imageNewDimensions.paddingHalf;

                
                // now calculate this distance from the left of image and convert to percentage
                const topPercentage = (shouldBeTopCoordinate / imageNewDimensions.newImgHeight)*100;
                
                hotSpotJSON.coordinates.yAxis = topPercentage;
            }else{
                // adjust left %age
                // what ever the coordinate get the % after adding one side of padding
                const shouldBeLeftCoordinate = currentImagePixelFromContainerLeft - imageNewDimensions.paddingHalf;

                // now calculate this distance from the left of image and convert to percentage
                const leftPercentage = (shouldBeLeftCoordinate / imageNewDimensions.newImgWidth)*100;
                
                hotSpotJSON.coordinates.xAxis = leftPercentage;
            }

                // console.log({
                //     currentImagePixelFromLeft,
                //     shouldBeLeftCoordinate,
                //     currentImagePixelFromTop,
                //     leftPercentage
                // });

                this.handleUpdateHotspot(hotSpotJSON, imageId);
            }


            
        } catch (error) {
            //console.log(error);
        }
    }
    
    handleTouchStart = (e)=>{
        e.stopPropagation();
        //console.log('touch start');

        e.target.addEventListener('touchmove', this.moveTouch);
    }

    handleTouchEnd = (e)=>{
        //console.log('touch end')
        e.target.removeEventListener('touchmove', this.move);
        return true;
    }

/*****************TOUCH SCREEN MOVE SUPPORT END***************************/

    render(){
        return (
            <>
                <Slider {...sliderSettings} 
                    className={[Styles['hotspot-slider'],'col-md-12'].join(' ')}  
                    style={{display:"flex"}} 
                    beforeChange = {(oldSlideIndex,newSlideIndex)=>this.handleBeforeChangeSlider(oldSlideIndex, newSlideIndex)}
                    afterChange = {(index)=>this.handleAfterChangeSlide({index})}
                    onInit = {()=>this.handleAfterChangeSlide(0)}
                >                
                {
                    this.state.imageList.length ? (
                        this.state.imageList.map((img,index)=>{
                            let imgURL = img['output_image_hres_url'] ; // as per dev, this property will always be there for a processed image
                                                
                            let imgId = img['image_id'] || imgURL;
                            let imgName = img['image_name'] || imgURL;
                            return (
                                <div className={[Styles['slickListContainer'], 'xslickListContainer'].join(' ')} ref={this.imgRef[index]} key={imgId} 
                                    id={imgId}
                                    onMouseMove={this.handleObjectMove}
                                >
                                    <img src={imgURL} alt={imgName} onClick={this.handleAddSimilarHotspot} id={imgId+'_img'} style={{cursor:'pointer'}}/>

                                    {/* Below section contains the hotspots */}
                                    {
                                        this.props.hotSpotMapObj.get(`${imgId}`) ? (
                                            [...this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.keys()].map(hotspotObjKey=>{
                                                return (
                                                    <img
                                                        src={this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotIconSrc}
                                                        className={[Styles['slickListContainerItemcentered']]}
                                                        onMouseDown={this.handleMouseDown}
                                                        onClick={this.handleHotSpotClick}
                                                        onTouchStart={this.handleTouchStart}
                                                        onTouchEnd={this.handleTouchEnd}
                                                        id={this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotId}
                                                        alt={this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotTitle}
                                                        key={this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotId}
                                                        // style={{left:`${this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.xAxis}%`, 
                                                        //         top:`${this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.yAxis}%`
                                                        // }}
                                                        style={{left:`${this.calculateLeftAsPerAspect(this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.xAxis)}%`, 
                                                                top:`${this.calculateTopAsPerAspect(this.props.hotSpotMapObj.get(`${imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.yAxis)}%`
                                                        }}
                                                    />  
                                                )
                                            })                                                         
                                                                
                                        ):(<></>)
                                    }

                                </div>
            
                            )    
                        })
                    )
                    :
                    (<img src={`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne/AI/raw/fe362e01-f1fe-49d1-8744-af5e14e6167d.jpg`} alt=""/>)
                }
                </Slider>
            </>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    //console.log('state.hotspotReducer.hotSpotMapObj',state.hotspotReducer.hotSpotMapObj);
    return {
        hotSpotMapObj : state.hotspotReducer.hotSpotMapObj,
        currentImageRef : state.hotspotReducer.currentImageRefObj,
        hotSpotId: state.hotspotReducer.hotSpotId,
        currentHotSpotObj: state.hotspotReducer.currentHotSpotObj,
        currentImageObj: state.hotspotReducer.currentImageObj,
        syncHotSpotTitleDescURL : state.hotspotReducer.syncHotSpotTitleDescURL
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        updateCurrentImage : (currentImageData) => dispatch(updateCurrentImage(currentImageData)),
        updateCurrentImageRef : (currImgRef) => dispatch(updateCurrentImageRef(currImgRef)),
        updateHotspot : (updatedHotSpot, imageId) => dispatch(updateHotspot(updatedHotSpot, imageId)),
        updateCurrentHotSpotId: (hotSpotId)=>dispatch(updateCurrentHotSpotId(hotSpotId)),
        addHotspot: (hotSpotJSON, imageId)=>dispatch(addHotspot(hotSpotJSON, imageId)), 
        updateCurrentHotSpotObj : (hotSpotObj) => dispatch(updateCurrentHotSpotObj(hotSpotObj))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HotspotImageTabView);